import { Navigate, useSearchParams } from 'react-router';

/** Legacy plans tab URL — open the adjust-plan dialog on overview instead. */
export const SubscriptionsPlansRedirect = () => {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  next.set('adjust', '1');
  return <Navigate to={`/subscriptions?${next.toString()}`} replace />;
};
